import React from "react";
import { Link } from "react-router-dom";
import "./CommonBtn.scss";
const CommonBtn = ({
  title,
  className,
  icon,
  onClick,
  to,
  role,
  disabled,
  type,
  iconBefore = false,
  iconAfter = false,
}) => {
  return (
    <>
      {(() => {
        switch (role) {
          case "btn":
            return (
              <button
                className={`commonBtn ${className}`}
                onClick={onClick}
                disabled={disabled}
                type={type}
              >
                {iconBefore && (
                  <>
                    <span>{iconBefore}</span>
                  </>
                )}
                {title && <>{title}</>}
                {iconAfter && (
                  <>
                    <span>{iconAfter}</span>
                  </>
                )}
              </button>
            );
          case "link":
            return (
              <Link
                to={to}
                className={`commonBtn ${className}`}
                onClick={onClick}
              >
                {iconBefore && (
                  <>
                    <span>{iconBefore}</span>
                  </>
                )}
                {title && <>{title}</>}
                {iconAfter && (
                  <>
                    <span>{iconAfter}</span>
                  </>
                )}
              </Link>
            );
          default:
            return null;
        }
      })()}
    </>
  );
};

export default CommonBtn;
